import { render, staticRenderFns } from "./ManFacter.vue?vue&type=template&id=07fc51ad&scoped=true"
import script from "./ManFacter.vue?vue&type=script&lang=js"
export * from "./ManFacter.vue?vue&type=script&lang=js"
import style0 from "./ManFacter.vue?vue&type=style&index=0&id=07fc51ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc51ad",
  null
  
)

export default component.exports